var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top',{attrs:{"refresh":_vm.refreshBanner}}),_c('zixun'),_c('cunzheng'),_c('dci'),_c('jiance')],1)}
var staticRenderFns = []

export { render, staticRenderFns }